function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { StoredValueAcccountRechargeTypeEnum, toLabel } from '../../../../reducers/constants/stored.value.account.recharge.type.constants';
import { createSelector } from 'reselect';
import { i18n, EnumHelper, MetadataConstants, MetadataSelectors } from 'invision-core';
import { SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../ewallet.constants';
import { SelectedPaymentMethodWithTypeNamesViewModelSelector, PaymentInstrumentsWithTypeNamesViewModel } from '../../../../reducers/selectors/customer.ewallet.selectors';
var paymentMethodTypeSelector = createSelector(SelectedPaymentMethodWithTypeNamesViewModelSelector, function (selectedPaymentMethod) {
  return selectedPaymentMethod ? selectedPaymentMethod.Type : null;
});
export var IsDirectDebitSelector = createSelector(paymentMethodTypeSelector, function (paymentType) {
  return paymentType !== null && paymentType.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.DIRECT_DEBIT.toString();
});
export var DirectDebitDetailSelector = createSelector(IsDirectDebitSelector, SelectedPaymentMethodWithTypeNamesViewModelSelector, function (isDirectDebit, paymentMethod) {
  return isDirectDebit && paymentMethod ? paymentMethod.DirectDebit : null;
});
export var IsAcpSelector = createSelector(paymentMethodTypeSelector, function (paymentType) {
  return paymentType !== null && paymentType.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.ACP.toString();
});
export var AcpDetailSelector = createSelector(IsAcpSelector, SelectedPaymentMethodWithTypeNamesViewModelSelector, function (isAcp, paymentMethod) {
  return isAcp && paymentMethod ? paymentMethod.AcpBill : null;
});
export var IsBraintreeSelector = createSelector(paymentMethodTypeSelector, function (paymentType) {
  return paymentType !== null && paymentType.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.BRAINTREE.toString();
});
export var BraintreeMethodTypeLookupSelector = createSelector(MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.BraintreeMethodType), function (braintreeMethodTypes) {
  if (braintreeMethodTypes && braintreeMethodTypes.length) {
    return braintreeMethodTypes.reduce(function (lookup, methodType) {
      var value = methodType.Value;
      lookup[value] = methodType;
      return lookup;
    }, {});
  }
  return {};
});
export var BraintreeDetailSelector = createSelector(IsBraintreeSelector, SelectedPaymentMethodWithTypeNamesViewModelSelector, BraintreeMethodTypeLookupSelector, function (isBraintree, paymentMethod, brainTreeMethodByType) {
  if (isBraintree && paymentMethod && paymentMethod.BraintreeMethod) {
    var braintree = paymentMethod.BraintreeMethod;
    var typeId = braintree.Type;
    var typeObj = brainTreeMethodByType[typeId.toString()];
    return Object.assign({}, braintree, {
      methodType: typeObj
    });
  }
  return null;
});
export var IsECheckSelector = createSelector(paymentMethodTypeSelector, function (paymentType) {
  return paymentType !== null && paymentType.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.E_CHECK.toString();
});
export var ECheckDetailSelector = createSelector(IsECheckSelector, SelectedPaymentMethodWithTypeNamesViewModelSelector, function (isECheck, paymentMethod) {
  return isECheck && paymentMethod ? paymentMethod.ECheck : null;
});
export var IsExternalBillSelector = createSelector(paymentMethodTypeSelector, function (paymentType) {
  return paymentType !== null && paymentType.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_BILL.toString();
});
export var ExternalBillDetailSelector = createSelector(IsExternalBillSelector, SelectedPaymentMethodWithTypeNamesViewModelSelector, function (isExternalBill, paymentMethod) {
  return isExternalBill && paymentMethod ? paymentMethod.ExternalBill : null;
});
export var IsRokuSelector = createSelector(paymentMethodTypeSelector, function (paymentType) {
  return paymentType !== null && paymentType.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.ROKU.toString();
});
export var RokuDetailSelector = createSelector(IsRokuSelector, SelectedPaymentMethodWithTypeNamesViewModelSelector, function (isRoku, paymentMethod) {
  return isRoku && paymentMethod ? paymentMethod.RokuAccount : null;
});
export var IsStoredValueAccountSelector = createSelector(paymentMethodTypeSelector, function (paymentType) {
  return paymentType !== null && paymentType.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.STORED_VALUE_ACCOUNT.toString();
});
export var BrandableCurrencyLookupSelector = createSelector(MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.BrandableCurrency), function (brandableCurrencies) {
  if (brandableCurrencies && brandableCurrencies.length) {
    return brandableCurrencies.reduce(function (lookup, brandableCurrency) {
      var value = brandableCurrency.Value;
      lookup[value] = brandableCurrency;
      return lookup;
    }, {});
  }
  return {};
});
export var StoredValueAccountDetailSelector = createSelector(IsStoredValueAccountSelector, SelectedPaymentMethodWithTypeNamesViewModelSelector, PaymentInstrumentsWithTypeNamesViewModel, BrandableCurrencyLookupSelector, function (isStoredValueAccount, selectedPaymentMethod, allPaymentMethods, brandableCurrenciesLookup) {
  if (isStoredValueAccount && selectedPaymentMethod) {
    var sva = selectedPaymentMethod.StoredValueAccount;
    var chargePaymentInstrumentId = sva.ChargePaymentInstrumentId;
    var chargePaymentInstrument = allPaymentMethods.find(function (pi) {
      return pi.Id === chargePaymentInstrumentId;
    });
    var brandableCurrency;
    if (sva.LoyaltyCard && sva.BrandableCurrency) {
      var brandableCurrencyId = sva.BrandableCurrency.toString();
      brandableCurrency = brandableCurrenciesLookup[brandableCurrencyId];
    }
    return Object.assign({}, sva, {
      chargePaymentInstrument: chargePaymentInstrument,
      brandableCurrency: brandableCurrency,
      frequency: getFrequency(sva)
    });
  }
  return null;
});
export var CurrentStateSelector = function CurrentStateSelector(state) {
  return state;
};
var paymentInstrumentMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_BILL, ExternalBillDetailSelector), SUPPORTED_PAYMENT_INSTRUMENT_TYPES.DIRECT_DEBIT, DirectDebitDetailSelector), SUPPORTED_PAYMENT_INSTRUMENT_TYPES.ACP, AcpDetailSelector), SUPPORTED_PAYMENT_INSTRUMENT_TYPES.BRAINTREE, BraintreeDetailSelector), SUPPORTED_PAYMENT_INSTRUMENT_TYPES.ROKU, RokuDetailSelector), SUPPORTED_PAYMENT_INSTRUMENT_TYPES.E_CHECK, ECheckDetailSelector), SUPPORTED_PAYMENT_INSTRUMENT_TYPES.STORED_VALUE_ACCOUNT, StoredValueAccountDetailSelector);
export var TemplatePaymentDetailSelector = createSelector(CurrentStateSelector, SelectedPaymentMethodWithTypeNamesViewModelSelector, function (state, selectedPayment) {
  if (selectedPayment && selectedPayment.Type && paymentInstrumentMap[selectedPayment.Type]) {
    var instrumentType = paymentInstrumentMap[selectedPayment.Type];
    return instrumentType(state);
  }
  return null;
});
var getFrequency = function getFrequency(sva) {
  var frequencyId = EnumHelper.getEnumOrDefault(sva.RechargePolicy, StoredValueAcccountRechargeTypeEnum, null);
  var frequencyQuantity = parseInt(sva.RechargeDays);
  var frequency = '';
  if (frequencyId !== null) {
    if (frequencyId === StoredValueAcccountRechargeTypeEnum.frequencyByDay && frequencyQuantity > 0) {
      frequency = getFrequencyByDayText(frequencyQuantity);
    } else {
      frequency = toLabel(frequencyId);
    }
  }
  return frequency;
};
var getFrequencyByDayText = function getFrequencyByDayText(frequencyQuantity) {
  switch (frequencyQuantity) {
    case 1:
      return i18n.translate(CustomerCareLocaleKeys.E_WALLET.STORED_VALUE_ACCOUNT.RECHARGE_TYPES.FREQUENCY_BY_DAY.ONE);
    case 2:
      return i18n.translate(CustomerCareLocaleKeys.E_WALLET.STORED_VALUE_ACCOUNT.RECHARGE_TYPES.FREQUENCY_BY_DAY.TWO);
    default:
      return i18n.translate(CustomerCareLocaleKeys.E_WALLET.STORED_VALUE_ACCOUNT.RECHARGE_TYPES.FREQUENCY_BY_DAY.MORE, {
        quantity: frequencyQuantity
      });
  }
};